module.exports = __webpack_public_path__ + "static/media/14.4159d752.jpg";